import { itemsToRuns } from './emphasis.js';
const BULLET_GLYPHS = ['•', '·', '▪', '‣', '●', '○', '◦', '►', '▶', '❯', '►', '◾', '◽', '▫', '◆', '◇'];
const DASH_BULLETS = ['*', '-', '–', '—'];
const ORDERED_PATTERNS = [
    /^\(?(\d{1,3})[.)、]\s+/, // 1. 1) (1) 1、
    /^([a-zA-Z])[.)]\s+/, //  a. A) a) — single-letter ordered
    /^([ivxlcdmIVXLCDM]{1,4})[.)]\s+/, // i. ii. iv. — roman numerals
];
const DEPTH_STEP_PT = 12; // ~one indent level
/** Identify list-marker on a line; if found, return the line info; otherwise return non-list. */
export function classifyListLine(line, columnXMin, baselineDepthX) {
    const runs = itemsToRuns(line.items);
    if (runs.length === 0) {
        return { isList: false, ordered: false, marker: '', depth: 0, runs };
    }
    // Reconstruct first chars of the line to detect marker.
    const firstRunText = runs[0].text;
    // Bullet glyph.
    for (const g of BULLET_GLYPHS) {
        if (firstRunText.startsWith(g)) {
            const trimmed = firstRunText.slice(g.length).replace(/^\s+/, '');
            const newRuns = [{ ...runs[0], text: trimmed }, ...runs.slice(1)];
            return {
                isList: true,
                ordered: false,
                marker: g,
                depth: depthOf(line.items[0]?.x ?? columnXMin, baselineDepthX),
                runs: dropEmptyRuns(newRuns),
            };
        }
    }
    // Dash/asterisk-style bullet — only count if followed by whitespace AND at line start (margin).
    for (const dash of DASH_BULLETS) {
        if (firstRunText.startsWith(dash + ' ') || firstRunText === dash) {
            const trimmed = firstRunText.slice(dash.length).replace(/^\s+/, '');
            const newRuns = [{ ...runs[0], text: trimmed }, ...runs.slice(1)];
            return {
                isList: true,
                ordered: false,
                marker: dash,
                depth: depthOf(line.items[0]?.x ?? columnXMin, baselineDepthX),
                runs: dropEmptyRuns(newRuns),
            };
        }
    }
    // Ordered patterns.
    for (const re of ORDERED_PATTERNS) {
        const match = re.exec(firstRunText);
        if (match) {
            const stripped = firstRunText.slice(match[0].length);
            const newRuns = [{ ...runs[0], text: stripped }, ...runs.slice(1)];
            return {
                isList: true,
                ordered: true,
                marker: match[0].trim(),
                depth: depthOf(line.items[0]?.x ?? columnXMin, baselineDepthX),
                runs: dropEmptyRuns(newRuns),
            };
        }
    }
    return { isList: false, ordered: false, marker: '', depth: 0, runs };
}
function depthOf(itemX, baseline) {
    const offset = itemX - baseline;
    if (offset <= DEPTH_STEP_PT * 0.5)
        return 0;
    return Math.min(4, Math.floor(offset / DEPTH_STEP_PT));
}
function dropEmptyRuns(runs) {
    return runs.filter((r) => r.text.trim().length > 0);
}
//# sourceMappingURL=lists.js.map